import React from 'react';
import classnames from 'classnames';
import styles from './DelegationStatement.scss';
import { Typography } from '@material-ui/core';

function DelegationStatement(props) {
    const {
        className,
        type = 'info',
        size = 'normal',
        condition = true,
        variant = 'body2',
        children,
    } = props;

    const classes = classnames(className, styles[type], styles[`size--${size}`]);

    return (
        <div style={{display: `${condition ? 'inline-block' : 'none'}`}} className={classes}>
            <Typography variant={variant}>
                {children}
            </Typography>
        </div>
    );
}

export default DelegationStatement;
